module.exports = __webpack_public_path__ + "img/085.0529acc8.png";